<!--Searchbar-->
<div class="row">
  <div class="col-12">
    <form [formGroup]="searchFilterForm" class="d-flex mb-3 px-1">
      <input formControlName="searchFilterField" class="form-control bar" type="search" placeholder="Cerca..."
        aria-label="Search">
      <button type="submit" class="bordersearch" (click)="clickSearch()"><i class="far fa-search grey"></i></button>
    </form>
  </div>
</div>

<!-- Filters -->
<div class="row mb-2">
  <div class="col-10 form-inline">

  </div>
  <div class="col-2 text fw-normal size16 txt-remove">

  </div>
</div>


<!-- Riga selezioni -->
<div class="row mt-4 my-2">
  <div class="col-8 text fw-normal size15">
    <span class="text fw-normal size15 txt-remove">
    </span>
  </div>
  <div class="col-4 text fw-normal size15 txt-remove">

  </div>
</div>



<!-- Table -->
<div [ngClass]="!isEmpty  ? 'table-responsive-sm blocks': 'not_visible'">
  <table aria-describedby=""  datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table  " style="width: 100%;">
    <thead>
      <tr class="back-white fw-bold">
        <th class="text-center pb-4 border-bottom-0" scope="col">
          <input class="form-check-input checkboxes" type="checkbox" value="" id="check_all" [checked]="statusCheckAll"
            (change)="onCheckAll()">
        </th>
        <th class="pb-4 border-bottom-0" scope="col">COMSY</th>
        <th class="pb-4 border-bottom-0" scope="col">Nome store</th>
        <th class="pb-4 border-bottom-0" scope="col">Indirizzo</th>
        <th class="pb-4 border-bottom-0" scope="col">Città</th>
        <th class="pb-4 border-bottom-0" scope="col">Nome</th>
        <th class="pb-4 border-bottom-0" scope="col">Cognome</th>
        <th class="pb-4 border-bottom-0" scope="col">Email</th>
        <th class="pb-4 border-bottom-0" scope="col"></th>
      </tr>
    </thead>
    <tbody [hidden]="isSearching">
      <tr class="table-font" *ngFor="let obj of entityList">
        <td class="text-center">
          <input class="form-check-input checkboxes" type="checkbox" value="" id="check_{{obj.id}}"
            [checked]="obj.checked" (change)="onCheckRow(obj.id)">
        </td>
        <td>{{obj.title}}</td>
        <td>{{obj.dealerDescription}}</td>
        <td>{{obj.location.normalizedAddress}}</td>
        <td>{{obj.location.normalizedCity}}</td>
        <td>{{obj.embeddedStoreManager.storeManagerName}}</td>
        <td>{{obj.embeddedStoreManager.storeManagerSurname}}</td>
        <td title="{{obj.embeddedStoreManager.storeManagerEmail}}" class="ellipsis">
          {{obj.embeddedStoreManager.storeManagerEmail}}</td>
        <td>
          <a class="btn btn-lg" (click)="clickButtonUpdate(obj.id)"><i class="far fa-pencil ora"></i></a>
        </td>
      </tr>
    </tbody>
    <tfoot [hidden]="!isSearching">
      <tr>
        <td colspan="9">
          <app-spinner-table [visible]="isSearching"></app-spinner-table>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
<div *ngIf="isEmpty" class="table-responsive-sm blocks no-data">
  <div class="result-message">
    <span class="message-font">La ricerca non ha prodotto risultati!</span>
  </div>
</div>